#import "../fragments/user-email-fragment.graphql"

mutation DisableSmtpConnection($userEmailId: ID!) {
    smtpConnectionDisable(input: {userEmailId: $userEmailId}) {
        userEmail {
            ...UserEmail
        }
    }
}
